import React, { useContext, Fragment } from 'react';
import ProductVariationContext from '@jetshop/core/components/ProductVariationProvider/ProductVariationContext';
import AddToCartFormik from '@jetshop/core/components/Mutation/AddToCartFormik';
import cartQuery from '../../Cart/CartQuery.gql';
import addToCartMutation from '../../Cart/addToCart.gql';
import ProductToastWrapper from './ProductToast';
import { toast } from 'react-toastify';

const AddToCartForm = ({ children }) => {
  const { product } = useContext(ProductVariationContext);
  const onAddToCartInit = ({ selectedVariation, mutationId }) => {
    toast(
      <ProductToastWrapper
        selectedVariation={selectedVariation}
        product={product}
      />,
      {
        autoClose: 2000,
        toastId: mutationId
      }
    );
  };
  const onAddToCartError = () => {
    return ({ selectedVariation, mutationId, error }) => {
      toast.dismiss(mutationId);
      toast(
        <ProductToastWrapper
          selectedVariation={selectedVariation}
          product={product}
          error={error}
        />,
        {
          autoClose: 5000,
          toastId: `${mutationId}--error`
        }
      );
    };
  };

  return (
    <AddToCartFormik
      onAddToCartInit={onAddToCartInit}
      onAddToCartError={onAddToCartError}
      cartQuery={cartQuery}
      cartMutation={addToCartMutation}
    >
      {props => <Fragment>{children(props)}</Fragment>}
    </AddToCartFormik>
  );
};

export default AddToCartForm;
